export interface QuotationAnalysisFormDefaultSettings {
	adminRate: number;
	assemblyRate: number;
	autoFormRate: number;
	designRate: number;
	engineeringRate: number;
	machineRate: number;
	qualityCostRate: number;
	qualityRate: number;
}

export class QuotationAnalysisFormDefaultSettings implements QuotationAnalysisFormDefaultSettings {
	constructor(data?: Partial<QuotationAnalysisFormDefaultSettings>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}